import styled from 'styled-components'
import { BREAKPOINT_SM } from '../../theme/ota'
import { CardContent } from '../HotelCart/styles'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const CartTitle = styled.h1`
  font-size: 14px;
  font-weight: 700;
  color: #273240;
  margin: 0;
`

export const CartItemsContainer = styled(CardContent)`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
`

export const CartItemsContainerWithoutIsCartView = styled.div`
  background-color: ${({ theme }) => theme?.colors?.white};
  color: ${({ theme }) => theme?.colors?.textColor};

  padding-bottom: 0px;

  p {
    margin-bottom: 0px;
    margin-top: 0px;
  }

  @media (min-width: calc(${BREAKPOINT_SM})) {
    width: 348px;
    padding-bottom: 20px;
  }
`

export const DividerContainer = styled.div`
  padding: 20px;
`
